import { Download, X } from 'lucide-react'
import { useInstallState } from '../hooks/use-install-state'

/**
 * Bottom-of-sidebar dismissible pill that nudges the user to install
 * the PWA when (a) the browser fired `beforeinstallprompt` AND (b) they
 * haven't dismissed it before. One click runs the native install prompt;
 * the X next to it persists the dismissal forever (per device).
 *
 * Hidden when the app is already installed, when the platform doesn't
 * support PWA install at all, or while in icon-only sidebar mode (the
 * full pill is too tall to fit).
 */
export function InstallSidebarPill() {
  const install = useInstallState()
  if (!install.shouldShowNudge || !install.canPromptNative) return null
  return (
    <div className="install-pill" role="region" aria-label="Instalar la app">
      <button
        type="button"
        className="install-pill-cta"
        onClick={() => {
          void install.prompt()
        }}
      >
        <Download size={14} aria-hidden="true" />
        <span className="install-pill-text">
          <strong>Instala la app</strong>
          <span className="install-pill-sub">1 clic · más rápida</span>
        </span>
      </button>
      <button
        type="button"
        className="install-pill-dismiss"
        aria-label="Descartar"
        onClick={install.dismissNudge}
      >
        <X size={12} aria-hidden="true" />
      </button>
    </div>
  )
}
